module.exports = __webpack_public_path__ + "static/customize1-22642ed06882849dc9e8711a60225bd0.png";